import { render, staticRenderFns } from "./WebsiteLayout.vue?vue&type=template&id=d6c78af8&"
import script from "./WebsiteLayout.vue?vue&type=script&lang=ts&"
export * from "./WebsiteLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports